import {
  SET_ENTERPRISE_ID,
  UPDATE_HOME_PAGE_NAV,
  UPDATE_CURRENT_HOME_PAGE_NAV_ID,
  UPDATE_CONFIG_COMPANY_ADDRESS,
  UPDATE_CURRENT_HOME_PAGE_NAV_INDEX
} from '../mutation-types'
import superagent from 'superagent'
import { RequestCommonResponse } from '../actions'
// import wxConfig from '../../assets/js/wx_config.js'
// import BMap from 'BMap'
const baseUrl = 'https://wx.dudubashi.com' // 替换为基本URL

const state = {
  home_page_nav: [],
  commuter_sub_nav: [],
  company_list: [],
  home_page_nav_id: null,
  home_page_nav_index: '',
  enterprise_id: null
}

const mutations = {
  [UPDATE_HOME_PAGE_NAV] (state, nav) {
    state.home_page_nav = nav
    for (var i = 0, len = nav.length; i < len; i++) {
      if (nav[i].id === '1' && nav[i].sub_navs.length > 0) {
        state.commuter_sub_nav = nav[i].sub_navs
      }
    }
  },
  [UPDATE_CURRENT_HOME_PAGE_NAV_ID] (state, id) {
    state.home_page_nav_id = id
  },
  [UPDATE_CURRENT_HOME_PAGE_NAV_INDEX] (state, index) {
    state.home_page_nav_index = index
  },
  [SET_ENTERPRISE_ID] (state, id) {
    state.enterprise_id = id
  },
  [UPDATE_CONFIG_COMPANY_ADDRESS] (state, list) {
    state.company_list = list
  }
}

const actions = {
  getHomePageNav ({ commit, state, rootState }) {
    return new Promise(function (resolve, reject) {
      superagent
      .post(baseUrl + '/index.php/line/enterprise/get_navs')
      .send({
        'enterprise_id': state.enterprise_id
      })
      .type('form')
      .end(function (err, res) {
        if (err) {
          throw err
        } else {
          res = JSON.parse(res.text)
          RequestCommonResponse({
            'rootState': rootState,
            'res': res,
            successCallback: function (res) {
              commit('UPDATE_HOME_PAGE_NAV', res.data)
              resolve(res)
            },
            failCallback: function (res) {
              reject(res)
            }
          })
        }
      })
    })
  },
  getCompanyAddress ({ commit, state, rootState }) {
    return new Promise(function (resolve, reject) {
      superagent
      .post(baseUrl + '/index.php/line/enterprise/get_address_info')
      .send({
        'enterprise_id': state.enterprise_id
      })
      .type('form')
      .end(function (err, res) {
        if (err) {
          throw err
        } else {
          res = JSON.parse(res.text)
          RequestCommonResponse({
            'rootState': rootState,
            'res': res,
            successCallback: function (res) {
              resolve(res)
            },
            failCallback: function (res) {
              reject(res)
            }
          })
        }
      })
    })
  },
  setCurrentHomeNavId ({ commit }, id) {
    commit('UPDATE_CURRENT_HOME_PAGE_NAV_ID', id)
  },
  setEnterpriseId ({ commit }, id) {
    commit('SET_ENTERPRISE_ID', id)
  },
  setCurrentHomeNavIdByKey ({ commit, state }, nav_id) {
    for (var i = 0, len = state.home_page_nav.length; i < len; i++) {
      var _nav = state.home_page_nav[i]
      if (_nav.id === nav_id) {
        commit('UPDATE_CURRENT_HOME_PAGE_NAV_ID', _nav.id)
        commit('UPDATE_CURRENT_HOME_PAGE_NAV_INDEX', i)
        if (_nav.sub_navs && _nav.sub_navs.length > 0) {
          state.commuter_sub_nav = _nav.sub_navs
        }
      }
    }
  },
  wxConfigFun ({ commit, state, rootState }, url) {
    return new Promise(function (resolve, reject) {
      var _url = url || window.location.href.split('#')[0]
      if (url && rootState.common && rootState.common.is_wx && !rootState.common.is_android) {
        // ios 中使用进入页面的href 进行获取微信授权 TODO 暂时屏蔽掉
        // _url = rootState.address.cache_entry_href
      }
      superagent
      .post(baseUrl + '/index.php/users/weixin/get_wx_sign_package', url)
      .send({
        share_url: encodeURIComponent(_url)
      })
      .type('form')
      .end(function (err, res) {
        if (err) throw err
        let _res
        if (res.text && res.text.result) {
          _res = JSON.parse(res.text)
        } else {
          _res = JSON.parse(res.xhr.response)
        }
        if (_res && _res.result === '0000') {
          // wxConfig(_res.data)
          resolve(_res.data)
        } else {
          resolve()
        }
      })
    })
  },
  wxShareConfig ({ commit }, data) {
    var share_title = data.share_title
    var share_desc = data.share_desc
    var share_timeline_title = data.share_timeline_title
    var share_url = data.share_url || window.location.href
    var share_img = data.share_img || window.location.origin + '/commuter/dist/static/img/enterprise/43_logo.png'
    window.wx.ready(function () {
      window.wx.onMenuShareTimeline({
        title: share_timeline_title,
        link: share_url,
        imgUrl: share_img,
        success: function () {
        },
        cancel: function () {
        }
      })
      window.wx.onMenuShareAppMessage({
        title: share_title,
        desc: share_desc,
        link: share_url,
        imgUrl: share_img,
        success: function () {
        },
        cancel: function () {
        }
      })
      window.wx.onMenuShareQZone({
        title: share_title,
        link: share_url,
        imgUrl: share_img,
        success: function () {
        },
        cancel: function () {
        }
      })
      window.wx.onMenuShareQQ({
        title: share_title,
        link: share_url,
        imgUrl: share_img,
        success: function () {
        },
        cancel: function () {
        }
      })
      window.wx.onMenuShareWeibo({
        title: share_title,
        link: share_url,
        imgUrl: share_img,
        success: function () {
        },
        cancel: function () {
        }
      })
    })
  }
}

export default {
  namespaced: true,
  actions,
  state,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/config.js